import { Component, OnChanges, Input, inject, SimpleChanges } from '@angular/core';
import { PriorityCode } from '../../../shared/priority-model';
import { ServiceSharedService } from '../../../shared/service-shared-services';
//import PriorityListJson from 'src/assets/data/ticket-header-priority.json';

@Component({
  selector: 'app-ticket-header-priority',
  templateUrl: './ticket-header-priority.component.html',
  styleUrls: ['./ticket-header-priority.component.scss'],
})

/**
 * TicketHeaderPriorityComponent is responsible for displaying the priority of a ticket.
 * It retrieves the priority information from the ServiceSharedService and updates the display accordingly.
 */
export class TicketHeaderPriorityComponent implements OnChanges {
  @Input() priority: number = 0;
  @Input() description: string = '';
  @Input() colorCode: any = undefined;

  private serviceSharedService = inject(ServiceSharedService);
  public priorityList: PriorityCode[] = [];

  constructor() {
    //on va feeder priorityList avec les données de l'API
    this.serviceSharedService.getListOfPriorityCode().subscribe((response: PriorityCode[]) => {
      this.priorityList = response;
    });
  }

  /**
   * ngOnChanges is a lifecycle hook that is called when any data-bound property of a directive changes.
   * It updates the color code and description based on the current priority value.
   * @param changes - SimpleChanges object containing the current and previous values of the input properties.
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['priority']) {
      let curVal = changes['priority'].currentValue;

      //on va tenter d'aller chercher dans la cache si on a pas trouvé dans la liste
      let priorityCode = this.priorityList.find((x) => x.idPriorite === curVal);

      //on va tenter de ramasser le code de couleur
      let MyNewColorCode: number = priorityCode?.codeCouleur ? parseInt(priorityCode.codeCouleur, 10) : 0;
      this.colorCode = this.getHexColorInverted(MyNewColorCode);

      if (priorityCode) {
        this.description = priorityCode.description ?? '';
      } else {
        this.description = curVal;
      }
    }
  }

  /**
   * Convert an integer color to a hex color string.  Note, ce qui vient de certain system (ex: servicentrE), le code est INVERSÉ (255=rouge, au lieude bleu, et blue c'est genre 130919479)
   */
  getHexColorInverted(intColor: number): string {
    const r = intColor & 0xff;
    const g = (intColor >> 8) & 0xff;
    const b = (intColor >> 16) & 0xff;

    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  }
}
